export const r = {
  return: {
    noReturnsAvailable: 'No returns available.',
    form: {
			instructions: 'Use the fields below to search for returns.',
			orderDate: 'Order Date',
			showOnlyOpenReturns: 'Show only open returns',
    },
    table: {
      header: {
        order: 'Return Order #',
        po: 'PO #',
        line: 'Line',
        product: 'Product',
        date: 'Date',
        qtyAuthorized: 'Quantity Authorized',
        qtyAccepted: 'Quantity Accepted',
        sellingAmount: 'Selling Amount',
        amountCredit: 'Amount Credit'
      }
    },
    details: {
      orderDetails: 'Order Details',
      returnOrder: 'Return Order #',
      orderStatus: 'Order Status',
      orderDate: 'Order Date',
      requestDate: 'Request Date',
      bookedDate: 'Booked Date',
      orderPricingSummary: 'Order Pricing Summary',
      orderSubTotal: 'Order Subtotal',
      tariffSurcharge: 'Tariff/Surcharge',
      shippingHandling: 'Shipping & Handling',
      orderTotal: 'Order Total',
      shippingInformation: 'Shipping Information',
      shippingAddress: 'Shipping Address',
      shippingMethod: 'Shipping Method',
      freightTerms: 'Freight Terms',
      email: 'Email',
      paymentMethod: 'Payment Method',
      poNumber: 'PO Number',
      paymentTerms: 'Payment Terms',
      billingAddress: 'Billing Address',
			items: 'Items',
      item: {
        line: 'Line #',
        itemDetails: 'Item Details',
        status: 'Status',
        weight: 'Weight',
        qtyAuth: 'QTY Auth',
        qtyAccept: 'QTY Accept',
        sellingAmount: 'Selling Amount',
        amountCredit: 'Amount Credit'
      },
      noItemsAvailable: 'No items available.',
			noContent: 'No Content',
    },
  },
};
